import { MdExpandMore } from "react-icons/md";

type Option = { value: string; label: string };

type SelectFieldProps<T> = {
  label?: string;
  subLabel?: string;
  hasRequiredLabel?: boolean;
  options?: Option[] | null;  // null/undefined 許容
  placeholder?: string;
  register?: any;
  errors?: any;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const SelectField = ({
  label,
  subLabel,
  hasRequiredLabel = false,
  options = [],   // ★ デフォルトを [] に
  placeholder,
  register,
  errors,
  ...restProps
}: SelectFieldProps<string>) => {
  return (
    <div className="m-form-item">
      <div className="m-form-item__header">
        {label && (
          <p className="m-form-item__caption">
            {label}
            {hasRequiredLabel && <span className="required">*</span>}
          </p>
        )}
        {subLabel && <p className="m-form-item__sub-caption">{subLabel}</p>}
      </div>
      <div className="m-form-item__input">
        <div className="m-form-item__input__container">
          <select {...register} {...restProps}>
            {placeholder && <option value="">{placeholder}</option>}
            {(options ?? []).map((option, idx) => (
              <option key={idx} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <div className="suffix-button">
            <MdExpandMore />
          </div>
        </div>
        {errors && register && errors[register.name] && (
          <p className="m-form-item__error">
            {String(errors[register.name]?.message || "入力エラー")}
          </p>
        )}
      </div>
    </div>
  );
};

export default SelectField;
